module.exports = __webpack_public_path__ + "media/images/change-caddc1a36165c9f38a62039bb451be9e.svg";